import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            backgroundColor: 'background.base.under',
        },
        container: {
            layerStyle: 'page',
            paddingY: {base: 'small-1.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            width: '100%',
            flexDirection: {base: 'column', lg: 'row'},
        },
        leftContainer: {
            flexDirection: 'column',
            height: 'stretch',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            flex: 1,
            width: {base: '100%', lg: '50%'},
        },
        mobileContainer: {
            flexDirection: 'column',
            height: 'stretch',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: {base: 'small-1.base', md: 'small-1.md'},
        },
        headerGrid: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            gap: 0,
        },
        title: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
        },
        description: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
        },
        benefitsContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
            width: '100%',
            maxWidth: {base: '100%', lg: remCalc(400)},
        },
        benefitItem: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            width: {base: '100%', lg: 'fit-content'},
            overflow: 'hidden',
            paddingX: {
                base: 'xsmall-1.base',
                md: 'xsmall-1.md',
                lg: 'xsmall-1.lg',
                xl: 'xsmall-1.xl',
            },
            paddingY: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
            border: 'none',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            borderRadius: {base: 'xl', lg: 'xxl'},
            backgroundColor: 'background.base.default',
        },
        benefitAccordionButtonContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },

            _hover: {
                backgroundColor: 'background.base.default',
            },
        },
        benefitIconAndTitleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
        },
        benefitPanel: {
            m: '0 !important',
            p: '0 !important',
        },
        iconBox: {
            boxSize: remCalc(10.8),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
        },
        benefitAccordionButton: {
            boxSize: remCalc(10.8),
        },
        benefitIcon: {
            boxSize: remCalc(20),
        },
        benefitTitle: {
            textStyle: 'body-large',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            textAlign: 'left',
        },
        benefitDescription: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'foreground.neutral.muted',
            textAlign: 'left',
        },
        image: {
            flex: '0 0 auto',
            width: {base: '100%', lg: remCalc(712)},
            height: 'auto',
            aspectRatio: '1 / 1',
            minHeight: {base: remCalc(378), lg: 'unset'},
            maxHeight: {base: 'unset', lg: remCalc(712)},
            objectFit: 'cover',
            borderRadius: {base: 'xl', lg: 'xl-1'},
        },
    },
    parts: [
        'container',
        'leftContainer',
        'mobileContainer',
        'headerGrid',
        'title',
        'description',
        'benefitsContainer',
        'benefitItem',
        'benefitAccordionButtonContainer',
        'benefitIconAndTitleContainer',
        'benefitPanel',
        'iconBox',
        'benefitAccordionButton',
        'benefitIcon',
        'benefitTitle',
        'benefitDescription',
        'image',
    ],
}
